import { render, staticRenderFns } from "./UserNotificationOrdersTable.vue?vue&type=template&id=37665d3f&"
import script from "./UserNotificationOrdersTable.vue?vue&type=script&lang=js&"
export * from "./UserNotificationOrdersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports